import { render, staticRenderFns } from "./empty-page.vue?vue&type=template&id=7ae66d63&scoped=true"
import script from "./empty-page.vue?vue&type=script&lang=js"
export * from "./empty-page.vue?vue&type=script&lang=js"
import style0 from "./empty-page.vue?vue&type=style&index=0&id=7ae66d63&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae66d63",
  null
  
)

export default component.exports